//#region Imports
import once from "lodash/once";
//#endregion

export function getSystemTimeZone() {
  // We can't cache `DateTimeFormat`
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const getSystemTimeZoneOnce = once(getSystemTimeZone);
